import { watch } from 'vue'
import type { useDepositTypesInterface } from './useDepositTypes'
import type { useInterestTagsInterface } from './useInterestTags'

/**
 * ผูกบริการที่สนใจกับหัตถการที่สนใจของฟอร์มนัดหมาย (LMP-7840) - เรียกครั้งเดียวใน setup ของฟอร์ม
 *
 * ตัวเลือกหัตถการ = หัตถการใต้บริการที่เลือก และเปลี่ยนบริการ = ล้างหัตถการที่เลือกไว้ (รวมตัวที่อยู่ทั้ง 2 บริการ)
 * ดูจาก object ของบริการที่เลือกแทนการเรียกตอนกดปุ่ม เพื่อให้ครอบคลุมทุกทางที่บริการเปลี่ยน: กดเลือก, resetDepositTypes
 * หลังสร้างนัด, initializeDepositTypes ที่ล้างบริการซึ่งหายจากรายการ และโหลดรายการใหม่ที่บริการเดิมยังอยู่แต่หัตถการ
 * เปลี่ยน (object ใหม่) - ฟอร์มจึงไม่ต้องเรียก initializeInterestTags เอง
 * ไม่ดูแค่ id: โหลดใหม่ id เดิมจะไม่ fire แล้วหัตถการเก่าค้าง ถูกส่งไปแล้ว backend ตัดทิ้งเงียบๆ
 * flush 'sync': state ตรงกันทันทีหลัง onSelectDepositType / resetDepositTypes - โค้ดที่อ่านต่อในฟังก์ชันเดียวกันไม่เจอค่าเก่า
 */
export function useAppointmentDepositTypeWithInterestTag(
  depositTypes: Pick<useDepositTypesInterface, 'selectedDepositType'>,
  interestTags: Pick<useInterestTagsInterface, 'initializeInterestTags'>,
) {
  watch(
    depositTypes.selectedDepositType,
    depositType => {
      interestTags.initializeInterestTags(depositType?.interest_tags ?? [])
    },
    { flush: 'sync' },
  )
}
